export enum AttachmentType {
  UserPlans = 'User',
  Plans = 'Plans'
}
